import useInitialLocation from 'app/hooks/useInitialLocation';
import { ReactNode } from 'react';
import { MemoryRouter } from 'react-router-dom';

const RouterWrapper = ({ children }: { children: ReactNode }) => {
  const { initialEntries, initialIndex } = useInitialLocation();

  return (
    <MemoryRouter
      initialEntries={initialEntries}
      initialIndex={initialIndex}
    >
      {children}
    </MemoryRouter>
  );
};

export default RouterWrapper;
